import type { Attrs } from "prosemirror-model";
import { type DragEvent as ReactDragEvent } from "react";

import { type ComponentTemplateGenerator } from "~/components/canvas/properties-pane/components-tab/ComponentTemplate";
import { type AutoImportInfo } from "~/state/types";

export interface DndComponentTemplate {
	cellNameTemplate: string;
	code: ComponentTemplateGenerator | ComponentTemplateGenerator[];
	autoImportInfo?: AutoImportInfo | AutoImportInfo[];
	attrs?: Attrs;
}

export const componentTemplateDataKey = "moment/componentTemplate/componentName";

export const getTemplateRaw = (e: DragEvent | ReactDragEvent) =>
	e.dataTransfer?.getData(componentTemplateDataKey);

export const onDragStartComponentTemplate = (template: DndComponentTemplate) => {
	return (e: React.DragEvent<HTMLDivElement>) => {
		const codeArray = Array.isArray(template.code) ? template.code : [template.code];
		const code = codeArray.map((c) => c.toString());

		e.dataTransfer.setData(
			componentTemplateDataKey,
			JSON.stringify({
				...template,
				code,
			})
		);
	};
};

const wrapCode = (code: string) => Function(`return ${code}`)();

export const hydrateDropComponentTemplate = (
	e: DragEvent | ReactDragEvent
): DndComponentTemplate | undefined => {
	const templateRaw = getTemplateRaw(e);
	if (templateRaw === undefined || templateRaw === "") {
		return undefined;
	}

	const { code, ...rest } = JSON.parse(templateRaw);
	const wrappedCode = Array.isArray(code) ? code.map(wrapCode) : wrapCode(code);

	return { code: wrappedCode, ...rest } as DndComponentTemplate;
};
